import { AxiosResponse } from "axios";

import { getAxiosInstance } from "@/apis/axios";
import commonApi from "@/apis/common/commonApi";

export const handleXsrfTokenMismatch = () => {
  return async (response: AxiosResponse): Promise<AxiosResponse> => {
    if (response.status !== 419) {
      return Promise.resolve(response);
    }

    try {
      await commonApi.getCsrfCookie();
    } catch (e) {
      return Promise.reject(e);
    }

    return getAxiosInstance().request(response.config);
  };
};
